import { get } from 'lodash';

import type { MaasGroupSpec } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

/** 规范化 Worker 组名称，用于重复比较 */
function normalizeWorkerGroupName(name?: string): string {
  return String(name || '')
    .trim()
    .toLowerCase();
}

/** 主从模式下 Worker 组保留名（与 Head 节点角色冲突，不可作为 Worker 组名） */
export function isWorkerGroupReservedRoleName(name?: string): boolean {
  const normalized = String(name || '')
    .trim()
    .toLowerCase();
  return normalized === 'master' || normalized === 'head';
}

/** Worker 列表中是否含主从模式保留名 */
export function hasWorkerGroupReservedRoleName(workers?: MaasGroupSpec[]): boolean {
  if (!workers?.length) return false;
  return workers.some((worker) => isWorkerGroupReservedRoleName(worker.name));
}

/** 多个 Worker 节点组名称是否重复 */
export function hasDuplicateWorkerGroupNames(workers?: MaasGroupSpec[]): boolean {
  if (!workers || workers.length <= 1) return false;
  const seen = new Set<string>();
  for (const worker of workers) {
    const key = normalizeWorkerGroupName(worker.name);
    if (!key) continue;
    if (seen.has(key)) return true;
    seen.add(key);
  }
  return false;
}

/** 校验 Worker 名称是否与同列表其他组重复（编辑时可排除当前索引） */
export function isWorkerGroupNameDuplicated(workers: MaasGroupSpec[], name: string, excludeIndex = -1): boolean {
  const key = normalizeWorkerGroupName(name);
  if (!key) return false;
  return workers.some((worker, index) => index !== excludeIndex && normalizeWorkerGroupName(worker.name) === key);
}

/** 校验节点 JSON 中的组资源（不要求 system，推理镜像在 _inferenceSystem） */
export function validateNodeGroupResource(group?: MaasGroupSpec): boolean {
  if (!group?.name || !group?.resource) return false;
  const resource = group.resource as Record<string, unknown>;
  const cpuVal = get(resource, 'cpu.request') ?? get(resource, 'cpu.cores');
  const memVal = get(resource, 'memory.request') ?? get(resource, 'memory.resource.memory.request');
  if (cpuVal === undefined || cpuVal === null || cpuVal === '') return false;
  if (memVal === undefined || memVal === null || memVal === '') return false;
  return true;
}
